/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-05-17 15:38:23
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-02 14:55:58
 */
import { message } from 'antd'
import axios from 'axios'
import { data } from 'jquery'
// axios.defaults.withCredentials=true      //对于附带身份凭证的请求，服务器不得设置 Access-Control-Allow-Origin 的值为“”。这是因为请求的首部中携带了 Cookie 信息，如果 Access-Control-Allow-Origin 的值为“”，请求将会失败。而将 Access-Control-Allow-Origin 的值设置为 http://foo.example，则请求将成功执行。
// const url = 'http://192.168.43.180:8010'  //
const url = global.url ? global.url.cd : null
const orderUrl = global.url ? global.url.order : null;
const demoUrl = global.url ? global.url.getFileShare : null;

export async function getMyCloudDisk(userId) {
    // return new Promise((resolve, reject) => {
    //     axios.get(url + '/clouddisk/user/' + userId).then((res) => {
    //         resolve(res.data.payload)
    //     }).catch((e) => {
    //         console.log(e)
    //         reject(e)
    //     })
    // })
    // debugger
    const { data: res } = await axios.get(url + '/clouddisk/user/' + userId)

    if (res.code === '200') {
        return res.payload
    }

}

/**
 * 查询默认顺序目录
 * @param {*} parentId 目录id
 * @param {*} flag 是否为个人云盘标识符
 * @param token
 * @returns 目录
 */
export async function getDiskCatalogue(parentId, flag = 1,token) {
    console.log(flag)
    if (flag) {
        const { data: res } = await axios.get(url + '/clouddisk/catalogue/' + parentId,{
            headers: {
                'Authorization': token
            }
        })
        if (res.code === '200') {
            return res.payload
        }
    } else {
        const { data: res } = await axios.get(url + '/publicclouddisk/' + parentId)
        console.log(res)
        if (res.code === '200') {
            return res.payload
        }
    }
}

/**
 * 查询名字正序目录
 * @param {*} parentId 目录id
 * @param {*} flag 是否为个人云盘标识符
 * @returns 目录
 */
export async function getDiskCatalogueName(parentId, flag) {
    if (flag) {
        const { data: res } = await axios.get(url + '/clouddisk/catalogue/name/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    } else {
        const { data: res } = await axios.get(url + '/publicclouddisk/nameAsc/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    }
}

/**
 * 查询名字倒序目录
 * @param {*} parentId 目录id
 * @param {*} flag 是否为个人云盘标识符
 * @returns 目录
 */
export async function getDiskCatalogueNameDesc(parentId, flag) {
    if (flag) {
        const { data: res } = await axios.get(url + '/clouddisk/catalogue/nameDesc/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    } else {
        const { data: res } = await axios.get(url + '/publicclouddisk/nameDesc/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    }
}

/**
 * 查询时间正序目录
 * @param {*} parentId 目录id
 * @param {*} flag 是否为个人云盘标识符
 * @returns 目录
 */
export async function getDiskCatalogueTime(parentId, flag) {
    if (flag) {
        const { data: res } = await axios.get(url + '/clouddisk/catalogue/timeAsc/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    } else {
        const { data: res } = await axios.get(url + '/publicclouddisk/timeAsc/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    }
}

/**
 * 查询时间倒序目录
 * @param {*} parentId 目录id
 * @param {*} flag 是否为个人云盘标识符
 * @returns 目录
 */
export async function getDiskCatalogueTimeDesc(parentId, flag) {
    if (flag) {
        const { data: res } = await axios.get(url + '/clouddisk/catalogue/timeDesc/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    } else {
        const { data: res } = await axios.get(url + '/publicclouddisk/timeDesc/' + parentId)
        if (res.code === '200') {
            return res.payload
        }
    }
}

/**
 * 将文件发布至公共云盘审核
 * @param {*} fileName 文件名
 * @param {*} privateCdId 文件id
 * @param {*} resourceType 文件类型
 * @param {*} userName 发布者用户名
 * @returns promise对象
 */
export async function uploadPublicCd(fileName, privateCdId, resourceType, userName) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url + '/publicclouddisk/upload',
            params: {
                fileName: fileName,
                privateCdId: privateCdId,
                resourceType: resourceType,
                userName: userName
            }
        }).then((res) => {
            console.log(res)
            if (res.data.code === '200') {
                resolve('发布成功')
            }
            if (res.data.code === '500') {
                resolve('文件已发布')
            }
        }).catch((e) => {
            console.log(e)
            reject('发布失败')
        })
    })
}

/**
 * 检测文件正确性
 * @param {string} resource 文件路径
 * @returns promise对象
 */
export async function check02(resource) {
    let resourcePath
    let flag = resource.indexOf('caplos.aircas.ac.cn')
    if (flag >= 0)
        resourcePath = resource.replace('https://caplos.aircas.ac.cn/cdoss/cdoss', 'http://10.0.31.121:8888')
    else
        resourcePath = resource.replace('https', 'http')
    console.log("resourcePath:", resourcePath);
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: demoUrl + '/checkout/ck02',
            params: {
                url: resourcePath
            }
        }).then((res) => {

            console.log(res)
            if (res.data.code === '200') {
                resolve('200')
            }
            if (res.data.code === '401') {
                reject(res.data.message)
            }
            if (res.data.code === '500') {
                reject(res.data.message)
            }
        }).catch((e) => {
            console.log(e)
            reject('文件检测失败')
        })
    })
}

/**
 * 检测35文件正确性
 * @param {*} resource 文件路径
 * @returns promise对象
 */
export async function check35(resource) {
    // debugger
    let resourcePath
    let flag = resource.indexOf('caplos.aircas.ac.cn')
    if (flag >= 0)
        resourcePath = resource.replace('https://caplos.aircas.ac.cn/cdoss/cdoss', 'http://10.0.31.121:8888')
    else
        resourcePath = resource.replace('https', 'http')
    console.log("resourcePath:", resourcePath);
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: demoUrl + '/checkout/ck35',
            params: {
                url: resourcePath
            }
        }).then((res) => {
            console.log(res)
            if (res.data.code === '200') {
                resolve('200')
            }
            if (res.data.code === '401') {
                reject(res.data.message)
            }
            if (res.data.code === '500') {
                reject(res.data.message)
            }
        }).catch((e) => {
            console.log(e)
            reject('文件检测失败')
        })
    })
}

/**
 * 检测35文件正确性
 * @param {*} resource 文件路径
 * @returns promise对象
 */
export async function checkMandt(resource) {
    let resourcePath
    let flag = resource.indexOf('caplos.aircas.ac.cn')
    if (flag >= 0)
        resourcePath = resource.replace('https://caplos.aircas.ac.cn/cdoss/cdoss', 'http://10.0.31.121:8888')
    else
        resourcePath = resource.replace('https', 'http')
    console.log("resourcePath:", resourcePath);
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: demoUrl + '/checkout/ckmandt',
            params: {
                url: resourcePath
            }
        }).then((res) => {
            console.log(res)
            if (res.data.code === '200') {
                resolve('200')
            }
            if (res.data.code === '401') {
                reject(res.data.message)
            }
            if (res.data.code === '500') {
                reject(res.data.message)
            }
        }).catch((e) => {
            console.log(e)
            reject('文件检测失败')
        })
    })
}

/**
 * 文件入库,修改文件入库状态
 * @param {*} fileId 文件Id
 * @returns promise对象
 */
export async function setDbState(fileId) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url + '/clouddisk/catalogue/setDbStatus?id=' + fileId,
        }).then((res) => {
            console.log(res)
            resolve(res.data.code)
        }).catch((e) => {
            console.log(e)
            reject(e)
        })
    })
}

/**
 * 文件入库，下共享订单（生成上传订单所需参数）
 * @param {*} params 参数
 * @returns promise对象
 */
export async function setDbIssue(params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: orderUrl + '/order/manage/issue',
            data: params
        }).then((res) => {
            console.log("setDbIssue", res)
            resolve(res.data)
        }).catch((e) => {
            console.log(e)
            reject(e)
        })
    })
}

/**
 * 文件入库，上传订单（运管）
 * @param {*} params 参数
 * @returns promise对象
 */
export async function setDbUploadOrder(params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: global.yunguanUploadOrder + '/managedeal/scdd/detailreceive',
            data: params
        }).then((res) => {
            console.log("setDbUploadOrder", res)
            resolve(res.data)
        }).catch((e) => {
            console.log(e)
            reject(e)
        })
    })
}

/**
 *
 * @param {*} folder:FolderInfo
 * @returns
 */
export async function saveFolder(folder) {
    return new Promise((resolve, reject) => {
        axios.post(url + '/clouddisk/catalogue/savefolder/', folder).then((res) => {
            console.log(res.data)
            if (res.data.code === '200') {
                resolve(res.data.payload)
            } else if (res.data.code === '500') {
                // resolve(res.data.payload)
            }

        }).catch((e) => {
            console.log(e)
            reject(e)
        })
    })

}

// export async function newFile(file) {
//     return new Promise((resolve, reject) => {
//         axios.post(url + '/clouddisk/catalogue/savefile/', file).then((res) => {
//             resolve(res.data.payload)
//         }).catch((e) => {
//             reject(e)
//         })
//     })

// }
export async function deleteFile(id,token) {
    return new Promise((resolve, reject) => {
        axios.delete(url + '/clouddisk/catalogue/delete/' + id,{
            headers: {
                'Authorization': token
            }
        }).then((res) => {
            if (res.data.code === '200') {
                message.success("删除成功！")
            }
            resolve(res.data.payload)
        }).catch((e) => {
            console.log(e)
            reject(e)
        })
    })

}

export async function uploadFile(data) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/oss/upload`, data, {
            headers: {
                "Content-Type": "multipart/form-data;"
            }
        }).then((res) => {
            resolve(res.data.payload)
        }).catch((e) => {
            console.log(e)
            reject(e)
        })
    })

}

export async function issueFile(file) {
    return new Promise((resolve, reject) => {
        axios.post(global.url.order + '/order/manage/issue', {
            fileName: file.name,
            fileSize: file.size,
            orderCacheAddr: file.resourcePath,
            resourceType: file.type,
        }).then((res) => {
            resolve(res.data)
        }).catch((e) => {
            console.log(e)
            reject(e)
        })
    })
}


/* 浙大入库相关接口 */
//基础入库接口，用于光学卫星、数据瓦片、产品瓦片、一般文件入库
//priority(0,1,2,3)，0的优先级最高
// 接收光学卫星数据、数据瓦片、产品瓦片、一般文件入库
// 参数

// - token
// - dataSource 数据源（文件）
// - dataType 数据类型
// - priority 优先级
// - userId 用户ID
export async function multipleUpload(params) {
    let formData = new FormData();
    formData.append("dataSource", params.file);
    return new Promise((resolve, reject) => {
        axios.put(`/zdUrl/api/multipleUpload??dataType=${params.dataType}&priority=${1}&userId=${params.zd_user.userId}`, {
            Authorization: params.zd_user.token,
            dataSource: params.file,
        }
        ).then((res) => {
            if (res.data.code = "0") message.success("已入库！");
            else message.error(res.data.info);
            resolve(res.data)
        }).catch((e) => {
            message.error("入库失败！");
            console.log(e)
            reject(e)
        })
    })
}

//产品文档入库接口
// 接收产品文档入库
// 参数

// - 参数
// - token
// - abs 摘要
// - dataSource 数据源（文件）
// - description 文档描述
// - docType 文档类型
// - keyword 关键词
// - priority 优先级
// - title 标题
// - userId 用户ID

// 输入示例：
// doctype分为“新闻信息类产品数据”、“标准规范类产品数据”、“政策法规类产品数据”、“产品质量检验成果”、“流程模块检验成果”、“技术原理及应用说明类产品数据”。
export async function prodDocumentUpload(params) {
    let formData = new FormData();
    formData.append("dataSource", params.file);
    return new Promise((resolve, reject) => {
        axios.put(`/zdUrl/api/prodDocumentUpload?abs=${params.DbInputSummaryOrNote}&description=${"暂无"}&docType=${"标准规范类产品数据"}&keyword=${params.DbInputName}&priority=${1}&title=${params.DbInputName}&userId=${params.zd_user.userId}`, {
            Authorization: params.zd_user.token,
            dataSource: params.file,
        }
        ).then((res) => {
            if (res.data.code = "0") message.success("已入库！");
            else message.error(res.data.info);
            resolve(res.data)
        }).catch((e) => {
            message.error("入库失败！");
            console.log(e)
            reject(e)
        })
    })
}

/* ------------------------------ */